import { render, staticRenderFns } from "./DonutChartHCA.vue?vue&type=template&id=5761b8c6"
import script from "./DonutChartHCA.vue?vue&type=script&lang=js"
export * from "./DonutChartHCA.vue?vue&type=script&lang=js"
import style0 from "./DonutChartHCA.vue?vue&type=style&index=0&id=5761b8c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports